
export class User {
    public mel: String;
    public id: string;
}
